<template>
  <div class="flex flex-col gap-4">
    <div class="flex flex-wrap gap-x-5 gap-y-2.5">
      <label
        v-for="platform in platforms"
        :key="'top-checkbox-' + platform.machineName"
        :class="[ 'flex w-fit items-center gap-2 text-sm font-medium text-foreground', disabled ? 'cursor-not-allowed' : 'cursor-pointer' ]"
      >
        <ui-checkbox
          :model-value="platformState(platform.machineName)"
          :disabled="disabled"
          @update:model-value="(checked) => setPlatform(platform.machineName, checked)"
        />
        {{ platform.label }}
      </label>
    </div>

    <div class="grid gap-4 border-t border-border pt-4 sm:grid-cols-2">
      <checkbox-list
        v-for="platform in platforms"
        :key="'bottom-checkbox-' + platform.machineName"
        v-model="entity.settings.adset_targeting_positions[platform.machineName]"
        :options="placementOptions(platform.machineName)"
        :disabled="disabled"
        vertical
      />
    </div>
  </div>
</template>

<script>
import { PLATFORMS } from '@/consts';
import CheckboxList from '@/ui/components/CheckboxList.vue';

export default {
  name: 'PlacementSelector',
  components: {
    CheckboxList,
  },
  props: {
    entity: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  computed: {
    adPlacements() {
      return this.$store.getters['app/facebookAdPlacements'];
    },
    platforms() {
      return PLATFORMS;
    },
  },
  methods: {
    placementOptions(platform) {
      return this.adPlacements[platform].map(placement => ({ value: placement.machine_name, label: this.tr(placement.label) }));
    },
    // All, none or some ('indeterminate') of the platform's placements.
    platformState(platform) {
      const selected = this.entity.settings.adset_targeting_positions[platform];
      if (selected.length === 0) {
        return false;
      }

      return selected.length === this.adPlacements[platform].length ? true : 'indeterminate';
    },
    setPlatform(platform, checked) {
      this.entity.settings.adset_targeting_positions[platform] = checked === true
        ? this.adPlacements[platform].map(placement => placement.machine_name)
        : [];
    },
  },
};
</script>
